import React, { useState, useEffect } from "react";
import Lenis from "lenis";
import "./App.css";
import Loader from "./components/Loader";
import CustomCursor from "./components/CustomCursor";
import BackgroundVideo from "./components/BackgroundVideo";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import ScrollBand from "./components/ScrollBand";
import Work from "./components/Work";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.5,
    });
    window.lenis = lenis;

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <Loader onDone={() => setReady(true)} />
      <CustomCursor />
      <BackgroundVideo />
      <Navbar />
      <main
        className="relative z-10"
        style={{ opacity: ready ? 1 : 0, transition: "opacity 0.6s ease" }}
      >
        <Hero />
        <About />
        <Services />
        <ScrollBand />
        <Work />
        <Testimonials />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}

export default App;
